import { render, staticRenderFns } from "./CustomerManager.vue?vue&type=template&id=5344899f&"
import script from "./CustomerManager.vue?vue&type=script&lang=js&"
export * from "./CustomerManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports